import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'guarantorsInformation/guarantors';

export const GUARANTORS_INFORMATION_TYPES = {
  SET_IS_SELF_GUARANTOR: `${actionsScope}/isSelfGuarantor`,
  UPDATE_GUARANTOR_FORM_VALUES: `${actionsScope}/updateGuarantorFormValues`,
  RESET_GUARANTOR_FORM_VALUES: `${actionsScope}/resetGuarantorFormValues`,
};

export const guarantorInformationActions = {
  setIsSelfGuarantor: createAction(
    GUARANTORS_INFORMATION_TYPES.SET_IS_SELF_GUARANTOR,
  ),
  updateGuarantorFormValues: createAction(
    GUARANTORS_INFORMATION_TYPES.UPDATE_GUARANTOR_FORM_VALUES,
  ),
  resetGuarantorFormValues: createAction(
    GUARANTORS_INFORMATION_TYPES.RESET_GUARANTOR_FORM_VALUES,
  ),
};



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/actions.js